import { Pagination, paginationToParams } from '../Pagination';

export interface HepsiburadaOrderFilter {
  pagination: Pagination;
}

export const getDefaultHepsiburadaOrderFilter = (): HepsiburadaOrderFilter => ({
  pagination: {
    page: 0,
    pageSize: 10,
  },
});

export const hepsiburadaOrderFilterToQueryParams = (
  filter: HepsiburadaOrderFilter,
) => ({
  ...paginationToParams(filter.pagination),
});
